var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loginConfirmShow)?_c('ConfirmDialog',{attrs:{"initOpen":true,"title":_vm.confirm.title,"content":_vm.confirm.message,"buttons":_vm.confirmDialogButtonConfig}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }